import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'
import { Form } from '@carsys/form'
import { BaseStepLayout } from '../BaseStepLayout'
import { StepNavigation } from '../StepNavigation'
import { defaultStepFormProps } from '../types.d'
import { WithRunInBackgroundHelper } from '../use-should-run-in-background'
import { InvoiceSequenceForm } from 'app/settings/components/InvoiceSequences/Form'
import { FormValues } from 'app/settings/components/InvoiceSequences/Types.d'
import React from 'react'
import moment from 'moment'
import { InvoiceType, InvoiceTypeWithVehicleSales, OnboardingStepKey } from '@cbgms/api'

const nonEmptyValues = (input: object): object => {
  const entriesWithActualValues = Object.entries(input).filter(([_, value]) => !!value)
  return Object.fromEntries(entriesWithActualValues)
}

interface InvoiceNumbersForm {
  onSubmit: (values: FormValues) => Promise<FormValues>
  invoiceType: InvoiceType | InvoiceTypeWithVehicleSales
  stepName: OnboardingStepKey
}

export const InvoiceNumbersForm: React.FC<defaultStepFormProps & InvoiceNumbersForm> = ({
  onSubmit,
  prevStep,
  isFirstStep,
  isPersisting,
  onSubmitSuccess,
  hideSkip,
  shouldRunInBackground,
  invoiceType,
  stepName,
  initialData
}) => {
  const { t } = useTranslation()

  const initialValues = React.useMemo(() => {
    return {
      Year: moment().year(),
      InvoiceType: invoiceType,
      NextNumber: 1,
      IsUpdatable: true,
      AutomatedInvoiceNumberRenewal: false,
      PatternYear: 'YY',
      PatternExtra: '',
      PatternNumbers: 'NNNNN',
      ...nonEmptyValues(initialData)
    }
  }, [invoiceType])

  return (
    <BaseStepLayout title={t(`onboarding.title_${stepName}`)} subTitles={[t('onboarding.invoice_numbers.step_info')]}>
      <Form<FormValues, FormValues>
        onSubmit={onSubmit}
        onSubmitSuccess={onSubmitSuccess}
        initialValues={initialValues}
        NavigationConfirmation={null}
        enableReinitialize
      >
        {({ isSubmitting, handleSubmit }) => (
          <WithRunInBackgroundHelper enabled={shouldRunInBackground} isSubmitting={isSubmitting} onSubmit={handleSubmit}>
            <Box>
              <InvoiceSequenceForm />
            </Box>
            <StepNavigation prevStep={prevStep} hideBack={isFirstStep} isLoading={isSubmitting || isPersisting} hideSkip={hideSkip} />
          </WithRunInBackgroundHelper>
        )}
      </Form>
    </BaseStepLayout>
  )
}
